export default __webpack_public_path__ + "static/media/visium-farm-logo.d9721289.png";